export default __webpack_public_path__ + "static/media/seductive_soup.600c798d.jpg";